import { render, staticRenderFns } from "./wbTitle.vue?vue&type=template&id=30c3d9d9&scoped=true&"
import script from "./wbTitle.vue?vue&type=script&lang=js&"
export * from "./wbTitle.vue?vue&type=script&lang=js&"
import style0 from "./wbTitle.vue?vue&type=style&index=0&id=30c3d9d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c3d9d9",
  null
  
)

export default component.exports